// extracted by mini-css-extract-plugin
export default {"employeeId":"styles_employeeId__eiy7n","tooltipPopper":"styles_tooltipPopper__EiF00","tooltip":"styles_tooltip__RbDQ4"};